import React, { useState } from "react";
import { api } from "@/lib/api";

export default function DocumentAIConnection({ status, onChange, disabled, expanded = false, initialProvider }) {
  const [provider, setProvider] = useState(initialProvider || status?.provider || "none");
  const [key, setKey] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const save = async () => {
    setBusy(true); setMessage("");
    try {
      const { data } = await api.put("/documents/ai/connection", { provider, ...(provider === "openai" ? { api_key: key } : {}) });
      setKey(""); onChange(data); setMessage(data.connected ? "OpenAI connected for your account." : "AI is off. Your saved connection was removed.");
    } catch (e) { setMessage(e.response?.data?.detail || "Could not update your connection."); }
    finally { setBusy(false); }
  };
  return <details open={expanded || undefined} className="document-ai-connection">
    <summary className="cursor-pointer py-3 text-sm">AI assistance · {status?.available ? "OpenAI connected" : "Not connected"}</summary>
    <fieldset disabled={busy || disabled} className="space-y-3 pb-4 min-w-0">
      <p className="text-sm">Optional. You can write, import text, and save work without AI.</p>
      <label className="block text-sm">Your provider
        <select aria-label="Your AI provider" value={provider} onChange={e => {setProvider(e.target.value); setKey(""); setMessage("");}} className="block w-full rounded-xl p-3 mt-1 subtle-border bg-white">
          <option value="none">No AI</option><option value="openai">OpenAI</option>
        </select>
      </label>
      {provider === "openai" && <>
        <label className="block text-sm">OpenAI API key
          <input type="password" autoComplete="off" spellCheck={false} value={key} onChange={e => setKey(e.target.value)} aria-label="OpenAI API key" placeholder={status?.connected ? "Enter a new key to replace your connection" : "Enter your API key"} className="block w-full rounded-xl p-3 mt-1 subtle-border bg-white" />
        </label>
        <p className="text-xs"><a href="https://platform.openai.com/api-keys" target="_blank" rel="noreferrer" className="underline">Manage OpenAI API keys</a></p>
        <p className="text-xs">Your key is encrypted on the server and belongs to your account. API usage is billed by OpenAI; a ChatGPT subscription alone does not provide API credits.</p>
        <p className="text-xs">Only when you choose an AI action will its receipt or document contents be sent to OpenAI. Review the result before saving or publishing.</p>
        {status?.can_connect === false && <p role="status" className="text-sm">Connections need administrator setup. The editor remains available.</p>}
      </>}
      <button type="button" onClick={save} disabled={busy || (provider === "openai" && (!key.trim() || status?.can_connect === false))} className="px-4 py-2 rounded-full subtle-border text-sm bg-white disabled:opacity-50">{busy ? "Connecting…" : provider === "none" ? (status?.connected ? "Disconnect OpenAI" : "Use without AI") : "Connect OpenAI"}</button>
      {message && <p role="status" className="text-sm">{message}</p>}
    </fieldset>
  </details>;
}
